"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _banner = require("@/api/banner/banner");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    type: Number
  },
  data: function data() {
    return {
      swiperList: []
    };
  },
  created: function created() {
    this.getSwiper();
  },
  methods: {
    //轮播图跳转
    toLink: function toLink(url) {
      if (url) {
        window.open(url);
      }
    },
    // 获取轮播图数据
    getSwiper: function getSwiper() {
      var _this = this;
      (0, _banner.getSwiperList)({
        param: this.prCode
      }).then(function (res) {
        _this.swiperList = res.data;
      });
    }
  }
};